module.exports = __webpack_public_path__ + "img/bg-poster-3.9852127d.webp";